import { flowPages, SignupFlowSlug } from "../constants";
import { useFlowNavigation } from "./useFlowNavigation";

export function useFreshSignupFlowNavigation(slug: SignupFlowSlug){
  return useFlowNavigation(slug, flowPages);
}